import React from "react";
import { Container } from "react-bootstrap";
import "./index.css";
import ProjectCarousel from "./Carousel";

function Projects() {
  return (
    <Container className="project-section">
      <h1 className="project-heading" style={{ textAlign: "center" }}>
        My Recent <strong className="">Works </strong>
      </h1>
      <div className="my-project">
        <ProjectCarousel />
      </div>
    </Container>
  );
}

export default Projects;
